var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 17,
    viewBox: "0 0 107 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.301238 0.262528C0.110427 0.465767 0 0.782191 0 1.19197V15.8087C0 16.2184 0.110427 16.5349 0.301238 16.7381L0.348332 16.7827L8.39814 8.59533V8.402L0.348332 0.214611L0.301238 0.262528Z",
    fill: "url(#paint0_linear_494_5101)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0787 11.3257L8.39844 8.59518V8.40185L11.082 5.67135L11.1421 5.70687L14.3201 7.54676C15.2271 8.0689 15.2271 8.92813 14.3201 9.45357L11.1421 11.2902L11.0787 11.3257Z",
    fill: "url(#paint1_linear_494_5101)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1418 11.2903L8.39818 8.49862L0.30127 16.7381C0.602508 17.0603 1.09375 17.0991 1.65238 16.7769L11.1418 11.2903Z",
    fill: "url(#paint2_linear_494_5101)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1418 5.70689L1.65238 0.220269C1.09375 -0.098634 0.602508 -0.0598049 0.30127 0.262403L8.39818 8.49854L11.1418 5.70689Z",
    fill: "url(#paint3_linear_494_5101)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8457 5.42128C47.5186 5.42128 45.6175 7.10055 45.6175 9.41747C45.6175 11.7156 47.5186 13.4125 49.8457 13.4125C52.1778 13.4125 54.0789 11.7156 54.0789 9.41747C54.0789 7.10055 52.1778 5.42128 49.8457 5.42128ZM49.8457 11.8389C48.5688 11.8389 47.4703 10.8396 47.4703 9.41747C47.4703 7.97659 48.5688 6.99486 49.8457 6.99486C51.1226 6.99486 52.2261 7.97659 52.2261 9.41747C52.2261 10.8396 51.1226 11.8389 49.8457 11.8389ZM40.6201 5.42128C38.288 5.42128 36.3919 7.10055 36.3919 9.41747C36.3919 11.7156 38.288 13.4125 40.6201 13.4125C42.951 13.4125 44.8484 11.7156 44.8484 9.41747C44.8484 7.10055 42.951 5.42128 40.6201 5.42128ZM40.6201 11.8389C39.342 11.8389 38.2397 10.8396 38.2397 9.41747C38.2397 7.97659 39.342 6.99486 40.6201 6.99486C41.897 6.99486 42.9956 7.97659 42.9956 9.41747C42.9956 10.8396 41.897 11.8389 40.6201 11.8389ZM29.6421 6.64609V8.34415H33.9186C33.7935 9.29299 33.4591 9.99053 32.9464 10.4767C32.3222 11.0639 31.35 11.7156 29.6421 11.7156C27.0103 11.7156 24.9494 9.70165 24.9494 7.20624C24.9494 4.71083 27.0103 2.69688 29.6421 2.69688C31.0651 2.69688 32.1005 3.22415 32.8647 3.9076L34.1267 2.71097C33.0579 1.74334 31.6361 0.999998 29.6421 0.999998C26.0331 0.999998 23 3.78429 23 7.20624C23 10.6282 26.0331 13.4125 29.6421 13.4125C31.5927 13.4125 33.0579 12.8065 34.2097 11.6698C35.39 10.5507 35.7578 8.9771 35.7578 7.70649C35.7578 7.31193 35.7231 6.94906 35.6612 6.64609H29.6421ZM74.5327 7.96249C74.1847 7.06884 73.1109 5.42128 70.9238 5.42128C68.7564 5.42128 66.9519 7.04066 66.9519 9.41747C66.9519 11.6557 68.7378 13.4125 71.1318 13.4125C73.0676 13.4125 74.1847 12.2934 74.6442 11.6416L73.2075 10.7339C72.7282 11.3985 72.0756 11.8389 71.1318 11.8389C70.1943 11.8389 69.5218 11.4314 69.0908 10.6282L74.7272 8.41695L74.5327 7.96249ZM68.7861 9.29299C68.7378 7.75229 70.0481 6.96316 70.9869 6.96316C71.7226 6.96316 72.3468 7.31193 72.5549 7.81101L68.7861 9.29299ZM64.2049 13.1694H66.0577V1.42627H64.2049V13.1694ZM61.1706 6.31141H61.1086C60.6925 5.84404 59.8986 5.42128 58.893 5.42128C56.7826 5.42128 54.853 7.17805 54.853 9.43039C54.853 11.6698 56.7826 13.4125 58.893 13.4125C59.8986 13.4125 60.6925 12.9862 61.1086 12.5047H61.1706V13.0778C61.1706 14.6056 60.3098 15.4264 58.9214 15.4264C57.7895 15.4264 57.0872 14.6514 56.7974 13.9996L55.1861 14.6373C55.6506 15.6965 56.8804 17 58.9214 17C61.0938 17 62.9268 15.7881 62.9268 12.8394V5.66437H61.1706V6.31141ZM59.0515 11.8389C57.7746 11.8389 56.7058 10.8255 56.7058 9.43039C56.7058 8.02238 57.7746 6.99486 59.0515 6.99486C60.3098 6.99486 61.3018 8.02238 61.3018 9.43039C61.3018 10.8255 60.3098 11.8389 59.0515 11.8389ZM83.2072 1.42627H78.7758V13.1694H80.6237V8.71993H83.2072C85.2594 8.71993 87.2719 7.31193 87.2719 5.07251C87.2719 2.83427 85.2544 1.42627 83.2072 1.42627ZM83.2555 7.08646H80.6237V3.05974H83.2555C84.6352 3.05974 85.4229 4.14598 85.4229 5.07251C85.4229 5.98143 84.6352 7.08646 83.2555 7.08646ZM94.6782 5.39897C93.3431 5.39897 91.9547 5.95794 91.3838 7.19684L93.0235 7.84859C93.3765 7.19684 94.0255 6.98547 94.7116 6.98547C95.6702 6.98547 96.6424 7.53152 96.6573 8.49563V8.61894C96.3229 8.43574 95.6071 8.16448 94.7265 8.16448C92.9604 8.16448 91.1608 9.08631 91.1608 10.8067C91.1608 12.3803 92.6074 13.3937 94.2336 13.3937C95.477 13.3937 96.1631 12.8617 96.5941 12.2429H96.6573V13.1506H98.442V8.64595C98.442 6.56389 96.8022 5.39897 94.6782 5.39897ZM94.4552 11.8342C93.8509 11.8342 93.0087 11.55 93.0087 10.8396C93.0087 9.93064 94.0589 9.58187 94.968 9.58187C95.7817 9.58187 96.1631 9.75215 96.6573 9.97644C96.5124 11.0639 95.5253 11.8342 94.4552 11.8342ZM104.944 5.65614L102.82 10.7468H102.757L100.561 5.65614H98.5683L101.868 12.7701L99.9851 16.7287H101.916L107 5.65614H104.944ZM88.2875 13.1694H90.1403V1.42627H88.2875V13.1694Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_494_5101",
    x1: 7.68342,
    y1: 15.9609,
    x2: -3.40706,
    y2: 5.06115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_494_5101",
    x1: 15.5011,
    y1: 8.49759,
    x2: -0.216502,
    y2: 8.49759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_494_5101",
    x1: 9.6499,
    y1: 6.98103,
    x2: -5.3897,
    y2: -7.79988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_494_5101",
    x1: -1.73689,
    y1: 21.6009,
    x2: 4.97896,
    y2: 15.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignGooglePlay);
export default __webpack_public_path__ + "static/media/signGooglePlay.1c7f27bcf6639f7b2b7bce0c2c2b8ffb.svg";
export { ForwardRef as ReactComponent };